import Cookies from 'js-cookie';
import { CSRF_TOKEN, SELECTED_TENANT } from '../constants/tokens';

export function removeTokenCookies() {
  Cookies.remove(CSRF_TOKEN);
  Cookies.remove(SELECTED_TENANT);
}
